window.collectionProductsSectionId = document.querySelector(
  '[data-section-type="collection-products"]'
)?.dataset.sectionId;

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const randomSortProducts = () => {
  const productGrid = document.querySelector(".product-grid");
  if (!productGrid) return;

  const productGroups = Array.from(
    productGrid.querySelectorAll(".product-main-group")
  );
  if (productGroups.length <= 1) return;

  const shuffledGroups = shuffleArray(productGroups);

  productGrid.innerHTML = "";
  shuffledGroups.forEach((group) => productGrid.appendChild(group));

  if (typeof initializeProductCards === "function") {
    initializeProductCards();
  }

  initializeCollectionPagination();
};

const initializeSortingModal = () => {
  const sortOptions = document.querySelectorAll(".sort-option");

  sortOptions.forEach((option) => {
    option.addEventListener("click", (event) => {
      if (option.dataset.sortType === "random") {
        event.preventDefault();

        sortOptions.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");

        const modal = document.querySelector('[data-modal="sorting-modal"]');
        if (modal) {
          modal.style.display = "none";
        }

        randomSortProducts();
      }
    });
  });

  // Auto-sorting on load was removed to avoid layout shift; trigger random sort server-side or via explicit user action instead.
};

/* Pagination buttons render with a data-page URL but no click behavior; wire it here since this file is shared by collection-products.liquid and main-clearance-collection.liquid. Clearance keeps Shopify's native server-rendered pagination (real data-page buttons) since it's designed to rarely paginate at all. */
const initializePaginationLinks = () => {
  const buttons = document.querySelectorAll(".pagination-container [data-page]");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      window.location.href = button.dataset.page;
    });
  });
};

/* Infinite scroll over CARDS. Each product renders one card per colour, so Shopify's product-based {% paginate %} can't split the grid — all cards render server-side and this reveals them CARDS_PER_BATCH at a time as the shopper nears the end of the grid. Clearance has no sentinel, so it keeps its server-rendered pagination. */
const CARDS_PER_BATCH = 8;
// Start revealing the next batch before the shopper actually reaches the end of the grid
const REVEAL_ROOT_MARGIN = "0px 0px 600px 0px";
let cardRevealState = null;

const revealNextCardBatch = () => {
  const state = cardRevealState;
  if (!state) return;

  state.revealed = Math.min(state.revealed + state.groupsPerBatch, state.groups.length);

  let viewedCards = 0;
  state.groups.forEach((group, index) => {
    const isVisible = index < state.revealed;
    group.classList.toggle("is-hidden", !isVisible);
    if (isVisible) viewedCards += group.querySelectorAll(".product-card").length;
  });

  if (state.viewCount) {
    state.viewCount.hidden = false;
    state.viewCount.textContent = `You've viewed ${viewedCards} of ${state.totalCards} products`;
  }

  if (state.revealed >= state.groups.length) {
    state.observer.disconnect();
    return;
  }

  // Re-observe so a sentinel that is still in range after this batch triggers the next one
  state.observer.unobserve(state.sentinel);
  state.observer.observe(state.sentinel);
};

const initializeCollectionPagination = () => {
  cardRevealState?.observer.disconnect();
  cardRevealState = null;

  const productsContainer = document.querySelector('[data-section-type="collection-products"]');
  const grid = productsContainer?.querySelector(".product-grid");
  const sentinel = productsContainer?.querySelector(".product-grid__sentinel");
  const viewCount = productsContainer?.querySelector(".product-view-count");
  if (!grid || !sentinel) return;

  const groups = [...grid.querySelectorAll(".product-main-group")];
  const totalCards = groups.reduce((count, group) => count + group.querySelectorAll(".product-card").length, 0);
  const groupsPerBatch = Math.max(1, Math.round(CARDS_PER_BATCH / 4));

  if (groups.length <= groupsPerBatch) {
    for (const group of groups) group.classList.remove("is-hidden");
    if (viewCount) viewCount.hidden = true;
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) revealNextCardBatch();
    },
    { rootMargin: REVEAL_ROOT_MARGIN }
  );

  cardRevealState = { groups, totalCards, groupsPerBatch, revealed: 0, viewCount, sentinel, observer };
  revealNextCardBatch();
};

window.initializePaginationLinks = initializePaginationLinks;
window.initializeCollectionPagination = initializeCollectionPagination;
window.initializeSortingModal = initializeSortingModal;

const CAROUSEL_HINT_INITIAL_DELAY = 1000;
const CAROUSEL_HINT_DELAY = 4000;
const CAROUSEL_HINT_DURATION = 1300; // matches the CSS shake animation duration
const CAROUSEL_HINT_REPEATS = 2; // must stay in sync with the CSS iteration count

const initializeFirstCardCarouselHint = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  // Swipe hint is a touch affordance — mobile only, desktop uses hover
  if (window.matchMedia("(min-width: 768px)").matches) return;

  // Skips display:none cards AND the grid's off-screen "hidden" variant cards, which are display:flex + visibility:hidden and so still have an offsetParent.
  const getFirstVisibleCard = () => {
    const cards = document.querySelectorAll(".product-grid .product-card");
    for (const card of cards) {
      if (card.offsetParent === null) continue;
      if (getComputedStyle(card).visibility === "hidden") continue;
      const rect = card.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;
      return card;
    }
    return null;
  };

  const getVisibleCarousel = (card) => {
    if (!card) return null;
    return (
      Array.from(card.querySelectorAll(".variant-carousel")).find(
        (c) => c.offsetParent !== null
      ) || card.querySelector(".embla")
    );
  };

  const hasMultipleImages = (card) => {
    const carousel = getVisibleCarousel(card);
    return !!carousel && carousel.querySelectorAll(".embla__slide").length > 1;
  };

  if (!hasMultipleImages(getFirstVisibleCard())) return;

  let idleTimer = null;

  const playHint = () => {
    const card = getFirstVisibleCard();
    if (card && hasMultipleImages(card)) {
      // Requiring canScrollPrev (not just !canScrollNext) avoids misfiring on desktop's hover layout, where Embla has a single in-flow slide and canScrollNext is always false.
      const emblaApi = getVisibleCarousel(card)?.emblaApi;
      const atEnd =
        !!emblaApi && emblaApi.canScrollPrev() && !emblaApi.canScrollNext();
      card.classList.toggle("pc-peek--right", atEnd);
      card.classList.add("pc-peek");
      setTimeout(() => {
        card.classList.remove("pc-peek", "pc-peek--right");
        scheduleHint();
      }, CAROUSEL_HINT_DURATION * CAROUSEL_HINT_REPEATS);
    } else {
      scheduleHint();
    }
  };

  const scheduleHint = () => {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(playHint, CAROUSEL_HINT_DELAY);
  };

  // Capture phase, not bubble: product-card-carousel.js's Embla init calls
  // stopPropagation() on these same event types directly on each carousel
  // element (to isolate its drag handling from the page). A bubble-phase
  // listener here would never see a swipe that started inside a carousel —
  // capture-phase listeners fire on the way down, before that stopPropagation
  // call runs, so genuine interaction is still detected as activity.
  const activityEvents = ["pointerdown", "pointermove", "wheel", "scroll", "keydown", "touchstart"];
  for (const eventName of activityEvents) {
    window.addEventListener(eventName, scheduleHint, { passive: true, capture: true });
  }

  // Initial delay lets the grid and Embla carousels finish settling before the first peek.
  setTimeout(playHint, CAROUSEL_HINT_INITIAL_DELAY);
};

document.addEventListener("DOMContentLoaded", () => {
  initializeCollectionPagination();
  initializePaginationLinks();
  initializeSortingModal();
  initializeFirstCardCarouselHint();
});
